import createRules from '../rules/index.js';
import simulateStateAfterOrder from './simulateStateAfterOrder.js';
import createStrategies from './createStrategies.js';
function createAgent(mapHexes, scenario, agentSide, hexProperties, strategyIngredients = []) {
    const strategies = createStrategies(agentSide, hexProperties, mapHexes, scenario, createRules(mapHexes, hexProperties), strategyIngredients);
    function collectOrders(gameState) {
        const orders = [];
        if (gameState.stateName === 'selectingForActivation') {
            const numOfFreshUnits = gameState.units.filter((u) => u.side === agentSide && !u.isFatigued).length;
            const maxNumOfOrders = numOfFreshUnits >= scenario.activationsPerTurn
                ? scenario.activationsPerTurn
                : numOfFreshUnits;
            let state = gameState;
            strategies.forEach(({ strategy, maxOrders }) => {
                let numOfOrders = 0;
                let ordersLimit = maxOrders >= 0 ? maxOrders : maxNumOfOrders;
                while (orders.length < maxNumOfOrders && numOfOrders < ordersLimit) {
                    const order = strategy.getMoveOrder(state);
                    if (!order) {
                        break;
                    }
                    orders.push(order);
                    numOfOrders += 1;
                    state = simulateStateAfterOrder(state, order);
                }
            });
        }
        return orders;
    }
    const agent = {
        getOrders: (gameState) => {
            return collectOrders(gameState);
        },
    };
    return agent;
}
export default createAgent;
